export const getPublishingCartQueryVariables = (ids: string[]) => ({
	filter: {
		product: {
			id: {
				_in: ids,
			},
		},
	},
});
